import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOpen = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 17 17",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(11.434 -0.944) rotate(45)",
		children: [
			/* @__PURE__ */ _jsx("g", {
				transform: "translate(15.67 11.478) rotate(180)",
				children: /* @__PURE__ */ _jsx("line", {
					x1: 11.1,
					y1: 10.4,
					x2: 11,
					y2: -.6,
					fill: "none",
					stroke: "currentColor",
					strokeWidth: 1.5,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.8,3.8l2.7-2.7l2.7,2.7",
				fill: "none",
				stroke: "currentColor",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
				d: "M10,3.3c3.1,3.1,3.1,7.9,0,10.9s-7.9,3.1-10.8,0s-3.1-7.9,0-10.9l0,0",
				fill: "none",
				stroke: "currentColor",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}) })
		]
	})
});
export { SvgOpen as ReactComponent };
